var ko = require('knockout'),
  APIHelper = require('_js/APIHelper');

function Employee(params, parent) {
  this.params = params;
  this.parent = parent;
  this.removed = ko.observable(false);
  this.isDeleting = ko.observable(false);
}

Employee.prototype.deleteEmployee = function() {
  var self = this;
  self.isDeleting(true);
  var url =
    self.parent.API.endAgencyConnectionForPersonUrl +
    '?aktorIdPerson=' +
    self.params.AktorId +
    '&aktorIdAgency=' +
    self.params.AgencyAktorId;
  var data = [];

  APIHelper.post(
    url,
    data,
    function() {
      self.isDeleting(false);
      self.removed(true);
    },
    function(response) {
      var location = window.location.href || document.URL;
      APIHelper.post('/api/log/error', {
        message: 'API-error: employee-list.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + response.responseText,
          'status: ' + response.status,
          'statusText: ' + response.statusText,
          'requestUrl: ' + url
        ]
      });
    }
  );
};

function BureauEmployees(params) {
  var self = this;

  self.params = params;
  self.aktorId = self.params.agencyaktorid;
  self.agencies = JSON.parse(self.params.agencies);
  self.API = self.params.api;
  self.aktorId = params.agencyaktorid;
  self.employeeArr = [];
  self.employeeList = ko.observableArray([]);
  self.dropdownTitle = ko.observable('Alle bedrifter');
  self.hasSubordinateOffices = ko.observable(false);
  self.ableToFetchMore = ko.observable(false);
  self.isLoading = ko.observable(false);
  self.removed = ko.observable(false);
  self.agency = ko.observable();
  self.activeModal = ko.observable(false);

  //Submodels
  self.agencyData = new AgencyData(); //Used under "Kontroll"

  this.init();
}

BureauEmployees.prototype.init = function() {
  this.getPageData();
};

BureauEmployees.prototype.getPageData = function() {
  var self = this;
  self.isLoading(true);

  //Agency data
  self.agencyData.setAgencyData(self.agencies);

  if (self.agencies.List.length > 0) {
    self.hasSubordinateOffices(true);
  } else {
    self.hasSubordinateOffices(false);
  }
  var url =
    self.API.getAllEmployeesForAllAgenciesInChain +
    '?agencyAktorId=' +
    self.aktorId;
  self.isLoading(true);

  self.employeeArr = [];
  self.getData(url, function(response) {
    response.forEach(function(employee) {
      self.employeeArr.push(new Employee(employee, self));
    });
    self.setEmployeeData(self.employeeArr);
  });
};

BureauEmployees.prototype.getData = function(url, callback) {
  var self = this;
  APIHelper.get(
    url,
    callback.bind(this),
    function() {
      self.isLoading(false);
    }.bind(this)
  );
};

BureauEmployees.prototype.setEmployeeData = function(data) {
  //Set data for employee table
  //Update employeeList
  this.employeeList(data);
  this.isLoading(false);
};

BureauEmployees.prototype.updateEmployeeList = function(parent, data) {
  var self = parent;
  self.isLoading(true);
  //Set data for employee table
  var tempData = [];

  for (var i = 0; i < data.length; i++) {
    for (var j = 0; j < self.employeeArr.length; j++) {
      if (self.employeeArr[j].params.AgencyAktorId === data[i]) {
        tempData.push(self.employeeArr[j]);
      }
    }
  }

  if (data.length === 0) {
    tempData = self.employeeArr;
  }

  self.setEmployeeData(tempData);
};

BureauEmployees.prototype.deleteEmployee = function(obj) {
  var url =
    this.API.endAgencyConnectionForPersonUrl +
    '?aktorIdPerson=' +
    obj.AktorId +
    '&aktorIdAgency=' +
    this.aktorId;

  this.deleteEmployeeFromAgency(url);
};

BureauEmployees.prototype.deleteEmployeeFromAgency = function(url) {
  var self = this;
  var data = [];

  APIHelper.post(
    url,
    data,
    function() {
      self.removed(true);
    },
    function(response) {
      var location = window.location.href || document.URL;
      APIHelper.post('/api/log/error', {
        message: 'API-error: employee-list.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + response.responseText,
          'status: ' + response.status,
          'statusText: ' + response.statusText,
          'requestUrl: ' + url
        ]
      });
    }
  );
};

BureauEmployees.prototype.toggleModal = function() {
  var self = this;
  self.activeModal(!self.activeModal());
};

/* Agency Data (Dropdown) */
function AgencyData() {
  this.agencyDataReady = ko.observable(false);
  this.agencyList = [];
  this.hasNoSubordinateOffices = ko.observable(false);
}

AgencyData.prototype.setAgencyData = function(agencies) {
  this.agencyList.push(agencies);
  this.agencyDataReady(true);
};

module.exports = BureauEmployees;
